import { defaulStateTable } from "@constants/defaultStates"
import { useAppSelector } from "@hooks/store"
import { getLogsData } from "@tcomponents/Logs/services/GET/getLogsData"
import useRedirectTo from "@thooks/useRedirectTo"
import { useCallback, useEffect, useMemo, useState } from "react"
import { columnsLogsTableFilters, columnsLogsTableHelper } from "../helpers/columnsLogsTableHelper"
import { checkParams, getColumnsFilter } from "@thelpers/customTableHelper"
import { getTableDataHelper } from "@thelpers/getTableDataHelper"

export const useLogs = ({ format, url, otherParams }) => {

    const { idToken, currentRol } = useAppSelector(state => state.auth)
    const { handleRedirectTo } = useRedirectTo()
    const [logsData, setLogsData] = useState(structuredClone(defaulStateTable))
    const [loadingLogsTable, setLoadingLogsTable] = useState(false);
    const serviceParams = useMemo(() => ({
        previousData: logsData?.dataTable,
        actualLimit: logsData?.metadata?.limit,
        limit: logsData?.metadata?.limit,
        currentPage: logsData?.currentPage,
        skip: 0
    }), [logsData])    

    const columns = useMemo(() => columnsLogsTableHelper({ columns: logsData?.columns }).map((column) => ({
        ...column,
        ...getColumnsFilter(column.dataIndex, columnsLogsTableFilters({ currentParams: logsData?.currentParams }))
    })), [logsData])

    const handleChangeTable = useCallback(async ({ pagination, filter, sorter }) => {
        let sort_order
        if (sorter.order === 'descend') sort_order = 'desc'
        if (sorter.order === 'ascend') sort_order = 'asc'

        const sort_by = sorter.column?.key
        const pageValue = pagination.current || logsData?.currentPage
        const newSkip = (pageValue * parseFloat(logsData?.metadata?.limit)) - parseFloat(logsData?.metadata?.limit)
        const actualParams = { ...logsData?.currentParams, otherParams }
        const newParams = {
            otherParams,
            find_by: actualParams.find_by ?? undefined,
            find_value: actualParams.find_value ?? undefined,
            sort_by,
            sort_order,
            skip: 0
        }
        let newPage = 1

        const finalParams = { ...serviceParams, ...newParams }

        if (checkParams({ actualParams, newParams, difKey: 'skip' })) {
            newPage = pageValue
            finalParams.skip = newSkip
        }

        setLoadingLogsTable(true)
        const res = await getLogsData({ ...finalParams, url, token: idToken, company_id: currentRol, format })
        const { data, metadata } = getTableDataHelper({
            data: res.data.data,
            metadata: res.data.metadata,
            skip: finalParams.skip,
            previousData: logsData?.dataTable,
            currentPage: logsData?.currentPage,
            limit: 10
        })
        setLogsData({
            ...logsData,
            currentPage: newPage,
            dataTable: data.dataSource,
            metadata: metadata,
            currentParams: newParams,

        })
        setLoadingLogsTable(false)
    }, [logsData, serviceParams, idToken, currentRol, url, format, otherParams])

    useEffect(() => {
        const getInitialData = async () => {
            // Fetch initial data here
            setLoadingLogsTable(true)
            const res = await getLogsData({
                url,
                token: idToken,
                company_id: currentRol,
                format,
                otherParams
            })
            if (format === 'list') {
                setLoadingLogsTable(false)
                return setLogsData(res.data.data)
            }
            const { data, metadata } = getTableDataHelper({
                data: res.data.data,
                metadata: res.data.metadata,
                skip: 0,
                previousData: defaulStateTable?.dataTable,
                currentPage: defaulStateTable?.currentPage,
                limit: 10
            })
            const defaultData = structuredClone(defaulStateTable)
            setLogsData({
                ...defaultData,
                dataTable: data.dataSource,
                metadata,
            })
            setLoadingLogsTable(false)
        }
        getInitialData()
    }, [idToken, currentRol])

    return {
        logsData,
        columns,
        loadingLogsTable,
        handleChangeTable,
        handleRedirectTo
    }

}